// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

export * from "./concat.common.js";
